module.exports = __webpack_public_path__ + "static/media/g6.fd841e24.jpg";